import { ConfigProvider, Form, Segmented } from "antd";
import { useTranslation } from "react-i18next";

const FormSegmented = ({
    label = "",
    name = "",
    placeholder = "",
    type = "text",
    size = "middle",
    onChange = () => { },
    className = "",
    subclassName = "",
    required = false,
    options = [],
    vertical = true,
    labelFontSize = "16px",
    fontWeight = "",
    bgColor = "#8A6FB9",
    textColor = "white"
}) => {

    const handleChange = (e) => {
        const value = e;
        onChange(value);
    };

    const { t, i18n } = useTranslation();

    const layout = {
        labelCol: {
            span: 24
        },
        wrapperCol: {
            span: 24
        }
    }

    return (
        <ConfigProvider theme={{
            components: {
                Form: {
                    labelFontSize: labelFontSize
                },
                Segmented: {
                    itemSelectedBg: bgColor,
                    itemSelectedColor: textColor
                }
            }
        }}>
            <Form.Item
                {...(vertical && layout)}
                label={label}
                name={name}
                required={required}
                style={{
                    fontWeight: fontWeight,
                    padding: "0px",
                    margin: "0px"
                }}
                rules={[{ required: required, message: i18n.language == 'th' ? 'กรุณากรอก ${label}' : '${label} is required' }]}
            >
                <Segmented
                    required
                    name={name}
                    label={label}
                    size={size}
                    options={options}
                    onChange={handleChange}
                />
            </Form.Item>
        </ConfigProvider>
    )

}

export default FormSegmented;